import React from "react"

const RedHeaders = ({ title }) => {
  return (
    <>
      <h3 className="text-xs font-thin py-0.5 uppercase tracking-wider text-red-600 font-body">
        {title}
      </h3>
    </>
  )
}

export default RedHeaders
